import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FltBrandBox = styled.div`
  .tabs-brand {
    ${mixin.flex({
      direction: 'column',
      justify: 'flex-end',
      align: 'stretch',
    })};
    overflow: hidden;
    position: relative;

    > .tabs-label {
      ${mixin.flex({ justify: 'flex-start' })};
      padding-top: 4px;
      padding-bottom: 20px;
      column-gap: 16px;

      .tabs-tab {
        transform: translateZ(0);
        width: auto;
        height: auto;
        font-size: 16px;
        font-weight: 500;
        color: #bbb;
      }

      .tabs-tab[aria-selected='true'] {
        color: #000;

        &::before {
          display: none;
        }
      }
    }

    > .tabs-cont {
      height: 332px;
      overflow: hidden;

      ul {
        overflow-y: auto;
        overflow-x: hidden;
        height: 332px;

        li {
          ${mixin.flex({ justify: 'flex-start' })};
          margin-top: 4px;

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }

    .input {
      margin-bottom: 20px;

      input:not(:placeholder-shown) + .btn-clear {
        right: 45px;
      }

      .btn-serach {
        width: 40px;
        height: 40px;
        flex: none;
        position: absolute;
        top: 0;
        right: 0;
        text-align: left;

        svg {
          width: 16px;
          height: 16px;
        }
      }

      input {
        width: 100%;
        height: 40px;
        padding: 0 80px 0 10px;
        color: #000;
        border-color: #e2e2e2;

        &:focus {
          border-color: #000;
        }
      }

      + ul {
        height: 270px;
      }

      + [data-testid='virtuoso-scroller'] {
        height: 270px !important;
      }
    }

    .tag-exclusive {
      color: #fff;
      background-color: #000;
      margin-left: 8px;
      transform: translateY(0);
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .tabs-brand {
      > .tabs-label {
        padding-top: ${mixin.pxToVw('4')};
        padding-bottom: ${mixin.pxToVw('20')};
        column-gap: ${mixin.pxToVw('16')};

        .tabs-tab {
          font-size: ${mixin.pxToVw('16')};
        }
      }

      > .tabs-cont {
        height: ${mixin.pxToVw('332')};

        ul {
          height: ${mixin.pxToVw('332')};

          li {
            margin-top: ${mixin.pxToVw('4')};
          }
        }

        .input {
          margin-bottom: ${mixin.pxToVw('20')};

          input:not(:placeholder-shown) + .btn-clear {
            right: ${mixin.pxToVw('45')};
          }

          .btn-serach {
            width: ${mixin.pxToVw('40')};
            height: ${mixin.pxToVw('40')};

            svg {
              width: ${mixin.pxToVw('16')};
              height: ${mixin.pxToVw('16')};
            }
          }

          input {
            height: ${mixin.pxToVw('40')};
            padding: ${mixin.pxToVw('0 80 0 10')};
          }

          + ul {
            height: ${mixin.pxToVw('270')};
          }

          + [data-testid='virtuoso-scroller'] {
            height: ${mixin.pxToVw('270')} !important;
          }
        }

        .tag-exclusive {
          margin-left: ${mixin.pxToVw('8')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 100%;
    /* background: red; */

    .tabs-brand {
      height: inherit;

      > .tabs-label .tabs-tab {
        font-size: 18px;
      }

      > .tabs-cont {
        height: inherit !important;

        ul {
          height: inherit !important;
        }

        ul,
        .ReactVirtualized__List {
          ::-webkit-scrollbar {
            width: 9px;
          }

          ::-webkit-scrollbar-thumb {
            border: 3px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            border-radius: 1em;
            background-color: #c4c4c4;
          }
        }
      }

      .input {
        .btn-serach {
          width: 48px;
          height: 48px;

          svg {
            width: 19px;
            height: 19px;
          }
        }

        input {
          height: 48px;
          padding: 0 88px 0 14px;
          font-size: 16px;
        }

        + [data-testid='virtuoso-scroller'],
        + ul {
          height: calc(100% - 70px) !important;
        }
      }

      .tag-exclusive {
        min-width: 30px;
        text-align: center;
        padding: 3px 5px;
        font-size: 11px;
      }
    }
  }
`;
